"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResolvedWeightWithTheme = exports.getResolvedWeight = void 0;

var _constants = require("./Text/constants");

// To Do (lindsey-menges): remove and just use StandardWeightMappings
// in v6 when legacy typography system is removed
var getResolvedWeight = function getResolvedWeight(fontFamily, textWeight) {
  if ((fontFamily === 'Caviar' || fontFamily === 'Caviar-Market') && _constants.CaviarWeights[textWeight]) {
    return _constants.CaviarWeights[textWeight];
  }

  if (_constants.Weights[textWeight]) {
    return _constants.Weights[textWeight];
  }

  return _constants.StandardWeightMappings[textWeight];
};

exports.getResolvedWeight = getResolvedWeight;

var getResolvedWeightWithTheme = function getResolvedWeightWithTheme(theme, textWeight) {
  return getResolvedWeight(theme.Typography.FontFamily, textWeight);
};

exports.getResolvedWeightWithTheme = getResolvedWeightWithTheme;